import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user';
import conf from './modules/conference';
import reg from './modules/registration';
import org from './modules/organization';
import sess from './modules/session';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        user,
        conf,
        reg,
        org,
        sess
    }
})
